module.exports = __webpack_public_path__ + "img/file-error.41e47350.svg";